import React, { Component } from 'react';
import { connect } from "react-redux"
import {ClipLoader} from 'react-spinners'
import { Button, Card, CardBody, Col, Container, Input, InputGroup, InputGroupAddon, InputGroupText, Row, Form } from 'reactstrap';
import {ToastDanger, ToastSuccess} from 'react-toastr-basic'
import {doSingIn, doResetPassword} from '../../../../js/firebase/firebase-auth'
import './Login.css'
import AuthenticatedRoute from '../../../../helpers/authentication/AuthenticatedRoute';
let timeout;
class Login extends Component {
  constructor(props){
    super(props)
    this.state = {
      user: {
        email: "",
        password: ""
      },
      loading: true
    }
  }
  componentWillReceiveProps = props => {
    if(!props.loggedUser) return;
    this.props.history.push('/dashboard')
    clearTimeout(timeout)
  }
  componentDidMount = () => {AuthenticatedRoute
    timeout = setTimeout(() => {
        this.setState({...this.state, loading: false})
    }, 1000)
  }
  login = () => {
    this.setState({...this.state, loading: true})
    const {email, password} = this.state.user;
    doSingIn(email, password)
      .catch(() => ToastDanger('Login ou senha inválidos!'))
  }

  resetPassword = () => {
    const {email} = this.state.user;
    if(!email) return ToastDanger('Campo e-mail inválido!')
    doResetPassword(email)
      .then(() => ToastSuccess('Um e-mail foi enviado para a recuperação da senha.'))
      .catch(() => ToastDanger('Usuário não cadastrado'))
  }

  handleChange = (key, value) => {
    this.setState({
      ...this.state,
      user: {
        ...this.state.user,
        [key]: value
      }
    })
  }
  render() {
    return (
        <div className="app flex-row align-items-center">
        {this.state.loading ?
          <ClipLoader loading={this.state.loading}/>:
          <Container>
            <Form>
            <Row className="justify-content-center">
              <Col md="6">
                <Card className="p-4">
                  <CardBody>
                    <h1>Login</h1>
                    <InputGroup className="mb-3">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-user"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input type="text" autoComplete="new-email" placeholder="E-mail" onChange={event => this.handleChange('email', event.target.value)}/>
                    </InputGroup>
                    <InputGroup className="mb-4">
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="icon-lock"></i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input type="password" autoComplete="new-password" placeholder="Password" onChange={event => this.handleChange('password', event.target.value)}/>
                    </InputGroup>
                    <Row>
                      <Col xs="6">
                        <Button color="primary" type="submit" className="px-4" onClick={this.login}>Login</Button>
                      </Col>
                      <Col xs="6" className="text-right">
                        <Button color="link" className="px-0" onClick={this.resetPassword}>Esqueci minha senha</Button>
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
              </Col>
            </Row>
            </Form>
          </Container>
        }
        </div>
    );
  }
}

const mapStateToProps = state => {
  return {
      loggedUser: state.userReducer.user
  }
}

export default connect(mapStateToProps)(Login);



// WEBPACK FOOTER //
// ./src/views/framework/Pages/Login/Login.js